<template>
  <div class="box-info my-5">
    <button
      class="box-info__button text-left d-flex align-items-center mx-auto w-1/1"
      @click="isModalOpen = true"
      :aria-controls="modalID"
    >
      <InfoIcon class="flex-shrink-0 mr-4" />
      <div
        class="box-info__button--text font-smaller"
        v-html="shortMessage"
      ></div>
    </button>
    <Modal
      :is-open="isModalOpen"
      :overlay-bg="true"
      :id="modalID"
      @close="isModalOpen = false"
    >
      <div class="box-info__modal text-center px-3">
        <h2
          v-if="modalTitle"
          class="h4 box-info__modal-title"
          v-text="modalTitle"
        ></h2>
        <div
          v-html="longMessage"
          class="box-info__modal-content text-black"
        ></div>
        <button
          v-if="modalCtaText"
          class="box-info__modal-cta btn -stroke mt-4"
          @click="isModalOpen = false"
          v-text="modalCtaText"
        ></button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from 'theme/components/utils/Modal.vue'
import InfoIcon from 'theme/components/icons/InfoIcon.vue'

export default {
  name: `BoxInfo`,
  props: {
    shortMessage: {
      type: String,
      required: true
    },
    longMessage: {
      type: String,
      required: true
    },
    modalTitle: {
      type: String,
      required: false,
      default: ''
    },
    modalCtaText: {
      type: String,
      required: false,
      default: ''
    },
    modalID: {
      type: String,
      required: false,
      default: 'box-info-modal'
    }
  },
  components: {
    Modal,
    InfoIcon
  },
  data() {
    return {
      isModalOpen: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/core';

.box-info {
  @include bp(md lg) {
    margin-inline: 4rem;
  }

  &__button {
    background-color: var(--zenith-component-background);
    padding: 2rem;
    border: none;

    &--text > :last-child {
      margin-bottom: 0;
    }
  }
}
</style>
